<template lang="pug" functional>
	.matrixRow
		.matrixRow-inner(:style="props.cols")
			.matrixCell(
				v-for="(cell, i) in props.data",
				:key="cell._id",
				:data-label="props.labels[i]",
				:class="cell._editorType")
				span.matrixCell-content(v-html="cell._display")
</template>

<script>
export default { name: "MatrixRow" };
</script>
